const LINKS = [
    { label: 'linkedin', href: 'https://www.linkedin.com/in/ricerob' },
    { label: 'email', href: 'mailto:riceslif@gmail.com' },
    { label: 'github', href: 'https://www.github.com/Ricerob' },
];

export default function Footer() {
    return (
        <footer className="footer-section px-4 md:px-10">
            <div className="footer-inner">
                <div className="reveal footer-links">
                    {LINKS.map(({ label, href }) => (
                        <a
                            key={label}
                            className="intro-link footer-link"
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {label}
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
}
